const de = {
  title: 'Stellenmarkt Einstellungen',
  prices: 'Preise',
  categories: 'Kategorien',
  duration: 'Dauer',
  factor: 'Faktor',
  price: 'Preis',
  factors: {
    year: 'Jahr',
    month: 'Monat',
    week: 'Woche',
    day: 'Tag'
  },
  paid: 'Kostenpflichtig',
  notPaid: 'Kostenlos',
  alerts: {
    saveTypeSuccessful: 'Die Kategorie wurde erfolgreich gespeichert.',
    saveTypeFailed: 'Die Kategorie konnte nicht gespeichert werden.',
    savePriceSuccessful: 'Der Preis wurde erfolgreich gespeichert.',
    savePriceFailed: 'Der Preis konnte nicht gespeichert werden.',
    errorLoading: 'Stellenmarkteinstellungen konnten nicht geladen werden.'
  },
  cancelConfirm: {
    message: 'Wollen Sie wirklich abbrechen? Nicht gespeicherte Änderungen gehen verloren.'
  }
};

export default de;
export type ManageJobMarketSettingsTranslation = typeof de;
